import React, {ReactNode} from "react";
import {ReactComponent as HomeIcon} from '../../../assets/navigate/home.svg';
import {ReactComponent as GroupsIcon} from '../../../assets/navigate/groups.svg';
import {ReactComponent as TestIcon} from '../../../assets/navigate/test.svg';
import {ReactComponent as CaseIcon} from '../../../assets/navigate/сase.svg';
import {ReactComponent as PaymentIcon} from '../../../assets/navigate/payment.svg';
import {ReactComponent as StatsIcon} from '../../../assets/navigate/stats.svg';
import {ReactComponent as TableIcon} from '../../../assets/navigate/table.svg';


type MenuItem = {
    icon: ReactNode;
    title: string;
    path: string;
};

export type RoleConfig = MenuItem[];


export type MenuConfig = {
    teacher: RoleConfig;
    hr: RoleConfig;
    'student-demo': RoleConfig;
    student: RoleConfig;
};

export const menuConfig: MenuConfig = {
    teacher: [
        { icon: <HomeIcon />, title: 'Личный кабинет', path: '/' },
        { icon: <GroupsIcon />, title: 'Группы', path: '/groups' },
        { icon: <TestIcon />, title: 'Тесты', path: '/test' },
    ],
    hr: [
        { icon: <TableIcon />, title: 'Сводная таблица', path: '/summary-table' },
        { icon: <GroupsIcon />, title: 'Группы', path: '/groups' },
        { icon: <StatsIcon />, title: 'Статистика', path: '/stats' },
    ],
    'student-demo': [
        { icon: <HomeIcon />, title: 'Личный кабинет', path: '/' },
        { icon: <GroupsIcon />, title: 'Демо уроки', path: '/lessons' },
        { icon: <TestIcon />, title: 'Тесты', path: '/test' },
        { icon: <CaseIcon />, title: 'Купить курс', path: '/buy-course' },
        { icon: <PaymentIcon />, title: 'История платежей', path: '/payment-history' },
    ],
    student: [
        { icon: <HomeIcon />, title: 'Личный кабинет', path: '/' },
        { icon: <GroupsIcon />, title: 'Группы', path: '/groups' },
        { icon: <TestIcon />, title: 'Тесты', path: '/test' },
        { icon: <CaseIcon />, title: 'Купить курс', path: '/buy-course' },
        { icon: <PaymentIcon />, title: 'История платежей', path: '/payment-history' },
    ],
};
